import React from 'react';
import styled from 'styled-components';
import {B2B2ProductCard} from './B2BProductCard';
import {Product} from '../../model/Products';

interface Props {
	targetProducts: Product[];
}

export const B2B2ProductCards: React.FC<Props> = (props: Props) => {
	const getProductsByNames = (names: Array<any>) => {
		return props.targetProducts.filter(
			function (val) {
				for (var i = 0; i < names.length; i++) {
					if (val.orderItemCode === names[i]) {
						return true;
					}
				}
				return false;
			}
		);
	}

	return (
		<ProductSelectionWrapper className={`product-selection`}>
			<PaddedRow className={'product-cards'}>
				<B2B2ProductCard products={getProductsByNames(["B2B_PACK_M2M"])} />
				<B2B2ProductCard products={getProductsByNames(["B2B_PACK_4G_BASIC_MOIPOT"])} />
				<B2B2ProductCard products={getProductsByNames(["B2B_PACK_4G_UNLIMITED"])} />
				<B2B2ProductCard products={getProductsByNames(["B2B_PACK_5G_400_4G_DISCOUNT", "B2B_PACK_5G_1000_4G_DISCOUNT"])} />
			</PaddedRow>
		</ProductSelectionWrapper>
	);
};

const ProductSelectionWrapper = styled.div`
	@media screen and (min-width: 1200px) {
		width: 100%;
	}

	@media screen and (min-width: 1000px and max-width: 1199px) {
		width: 100%;
	}

	.column,
	.columns {
		margin: 0;
		padding: 0;
	}
`;

const PaddedRow = styled.div`
	padding: 1rem 0;

	&.product-cards {
		padding-top: 0;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: stretch;
		flex-wrap: wrap;
		margin-bottom: 20px;

		@media screen and (min-width: 700px) and (max-width: 1300px) {
			/*display: grid;
			grid-template-columns: 48% 48%;
			grid-template-rows: 1fr 1fr;
			grid-gap: 2%;
			grid-row-gap: 2%;
			grid-column-align: center;
			padding: 0 4%;
			justify-items: center;
			margin-bottom: 3rem;*/

			div.has-tabs {
				width: calc(50% - 10px);
				max-width: none;
			}
		}

		@media screen and (max-width: 699px) {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			max-width: 600px;
			margin: 0 auto;
			padding: 0 20px;
		}
	}
`;
